export const POLO_SHIRTS_WOMEN_ESSENTIALS_BRK = [
  {
    title: 'POLO MICROPIQUÉ P010W',
    description: '100% Polyester Micropiqué',
    price: '35€',
    colors: ['#ffffff', '#beddef', '#f5dbeb', '#212e43', '#191819'],
    image_product:
      '/images/essentials/polo-marino-liso-tecnico-mujer-brk-1_jpg.webp',
  },
  {
    title: 'POLO PERFORMANCE P115W',
    description: '100% Polyester Micropiqué',
    price: '35€',
    colors: ['#ffffff', '#beddef', '#f5dbeb', '#212e43', '#191819'],
    image_product: '/images/essentials/polo-esencial-pique-azul.webp',
  },
  {
    title: 'POLO MICROPIQUÉ P010WS',
    description: '100% Polyester Aerosilver Micropique',
    price: '35€',
    colors: ['#ffffff', '#beddef', '#f5dbeb', '#212e43', '#191819'],
    image_product: '/images/essentials/polo-blanco-liso-sin-mangas.webp',
  },
  {
    title: 'POLO PERFORMANCE PRO P220WS',
    description: 'Recycled Polyamide 90% Elastane 10%',
    price: '35€',
    colors: ['#ffffff', '#beddef', '#f5dbeb', '#212e43', '#191819'],
    image_product:
      '/images/essentials/polo-blanco-esencial-sin-mangas-poliamida.webp',
  },
];

export const MIDLAYERS_WOMEN_ESSENTIALS_BRK = [
  {
    title: 'MID LAYER PERFORMANCE PRO M210W',
    description: 'Recycled Polyamide 91% Elastane 9%',
    price: '35€',
    colors: ['#babebb', '#212e43', '#191819'],
    image_product: '/images/essentials/mid-layer-liso-esencial-women.webp',
  },
  {
    title: 'MID LAYER PERFORMANCE PRO M210W',
    description: 'Recycled Polyamide 91% Elastane 9%',
    price: '35€',
    colors: ['#babebb', '#212e43', '#191819'],
    image_product:
      '/images/essentials/midlayer-tecnico-performance-blanco-brk-1_jpg.webp',
  },
  {
    title: 'CORTAVIENTOS PERFORMANCE PRO W310W',
    description: 'Polyester 97% Elastane 3%',
    price: '35€',
    colors: ['#babebb', '#212e43', '#191819'],
    image_product: '/images/essentials/windstopper-women.webp',
  },
];

export const VEST_WOMEN_ESSENTIALS_BRK = [
  {
    title: 'CHALECO PERFORMANCE PRO V210',
    description: 'Recycled Polyamide 91% Elastane 9%',
    price: '35€',
    colors: ['#ffffff', '#babebb', '#212e43', '#191819'],
    image_product: '/images/essentials/chaleco-negro-2.webp',
  },
  {
    title: 'CHALECO PERFORMANCE PRO V320',
    description: '97% Polyester 3% Elastane',
    price: '35€',
    colors: ['#ffffff', '#babebb', '#212e43', '#191819'],
    image_product: '/images/essentials/VEST-GRIS.jpg',
  },
  {
    title: 'CORTAVIENTOS PERFORMANCE PRO W310',
    description: 'Polyester 97% Elastane 3%',
    price: '35€',
    colors: ['#babebb', '#212e43', '#191819'],
    image_product: '/images/essentials/WINDSTOPPER_MEN.webp',
  },
];
